<template>
  <RevContentBlock
    class="flex justify-end px-56 py-16"
    :image-props
    :surtitle="i18n(translations.surtitle)"
    :title="i18n(translations.title)"
  >
    <slot />
  </RevContentBlock>
</template>

<script setup lang="ts">
import { useI18n } from '@backmarket/nuxt-module-i18n/useI18n'
import { RevContentBlock } from '@ds/components/ContentBlock'

import translations from './NoRequestFoundBlock.translations'

const i18n = useI18n()
const imageProps = {
  alt: '',
  height: 257,
  src: '/img/customer-care/trip-mountains.svg',
  width: 465,
  style: 'max-height: 465px',
}
</script>
